import React from "react";
import { Button } from "reactstrap";

const Blog = (props) => {
    return (
        <div class="blog-container">
            <img src={props.pictureURL} alt="Blog" />
            <div class="txt-container">
                <div class="txt">{props.title}</div>
                <div class="btn-container">
                    <div class="btn" onClick={() => window.open(props.blog_link, "_blank")}> lire la suite </div>
                </div>
            </div>
        </div>)
}

export default Blog;